import { Injectable } from '@angular/core';
import { API_URLS } from 'src/environments/env-routes';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';
import { PULSE_CMM } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CmmService {
  public loadedAspects = [];

  constructor(private api: APIHelper) { }

  _setUrlModelName(url: String, modelName?: any) {
    return url.replace(':modelName', modelName ? modelName : PULSE_CMM);
  }

  async loadAllAspectsAndStoreThemLocally() {
    const aspectsResponse = await this.listAspects();
    this.loadedAspects = aspectsResponse.list.entries;
  }

  createAspect(data: any) {
    return this.api
      .requestApi({
        action: this._setUrlModelName(API_URLS.cmm.createAspect, data.modelName),
        method: 'POST',
        datas: data.data
      })
      .then(res => {
        return res;
      });
  }

  updateAspect(data: any) {
    return this.api
      .requestApi({
        action: this._setUrlModelName(API_URLS.cmm.editAspect, data.modelName).replace(':aspectName', data.aspectName),
        method: 'PUT',
        datas: data.data
      })
      .then(res => {
        return res;
      });
  }

  deleteAspect(data: any) {
    return this.api
      .requestApi({
        action: this._setUrlModelName(API_URLS.cmm.deleteAspect, data.modelName).replace(':aspectName', data.aspectName),
        method: 'DELETE'
      })
      .then(res => {
        return res;
      });
  }

  getAspect(data: any) {
    return this.api
      .requestApi({
        action: this._setUrlModelName(API_URLS.cmm.getAspect, data.modelName).replace(':aspectName', data.aspectName),
        method: 'GET'
      })
      .then(res => {
        return res;
      });
  }

  listAspects(data?: any) {
    return this.api
      .requestApi({
        action: this._setUrlModelName(API_URLS.cmm.listAspects, data ? data.modelName : null),
        method: 'GET'
      })
      .then(res => {
        return res;
      });
  }

  createProperty(data: any) {
    let args =
      'select=props';

    return this.api
      .requestApi({
        action: this._setUrlModelName(API_URLS.cmm.createProperty, data.modelName)
          .replace(':entityClass', data.entityClass)
          .replace(':entityName', data.entityName),
        method: 'PUT',
        datas: data.data,
        queryArgs: args
      })
      .then(res => {
        return res;
      });
  }

  createPropertyForAspect(data: any) {
    return this.createProperty(Object.assign({entityClass: 'aspects'}, data));
  }

  createPropertyForType(data: any) {
    return this.createProperty(Object.assign({entityClass: 'types'}, data));
  }

  updateProperty(data: any) {
    let args =
      'select=props&update=' + data.propertyName;

    return this.api
      .requestApi({
        action: this._setUrlModelName(API_URLS.cmm.editProperty, data.modelName)
          .replace(':entityClass', data.entityClass)
          .replace(':entityName', data.entityName),
        method: 'PUT',
        datas: data.data,
        queryArgs: args
      })
      .then(res => {
        return res;
      });
  }

  deleteProperty(data: any) {
    let args =
      'select=props&delete=' + data.propertyName;

    return this.api
      .requestApi({
        action: this._setUrlModelName(API_URLS.cmm.deleteProperty, data.modelName)
          .replace(':entityClass', data.entityClass)
          .replace(':entityName', data.entityName),
        method: 'PUT',
        datas: data.data,
        queryArgs: args
      })
      .then(res => {
        return res;
      });
  }
}
